var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 28,
    viewBox: "0 0 311 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.188 22.5282C1.26 22.4802 0.888 22.7801 0.072 23.4282V28.0002H18.144L18.1441 28.0001H309.494C310.322 28.0001 310.994 27.3285 310.994 26.5001C310.994 25.6716 310.322 25.0001 309.494 25.0001H22.555L22.5552 24.9999H15.1239H6.47949C9.19148 22.9119 13.368 18.7722 15.12 16.5882C16.872 14.3802 17.748 11.9922 17.748 9.42415C17.748 7.07215 17.016 5.16415 15.552 3.70015C14.112 2.23615 11.964 1.50415 9.108 1.50415C7.452 1.50415 5.94 1.82815 4.572 2.47615C3.228 3.12415 2.136 4.13215 1.296 5.50015C0.48 6.86815 0.048 8.57215 0 10.6122H5.94C5.94 9.36415 6.192 8.40415 6.696 7.73215C7.224 7.03615 7.944 6.68815 8.856 6.68815C9.768 6.68815 10.452 6.96415 10.908 7.51615C11.364 8.06815 11.592 8.83615 11.592 9.82015C11.592 11.1162 11.124 12.4482 10.188 13.8162C9.252 15.1842 8.1 16.4922 6.732 17.7402C5.388 18.9881 3.54 20.5842 1.188 22.5282Z",
    fill: "url(#paint0_linear_189_24889)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_189_24889",
    x1: -2.5862,
    y1: -46.0123,
    x2: 451.217,
    y2: 43.2117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5249AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362999,
    stopColor: "#FC7765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6407,
    stopColor: "#C7BEFC",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957743,
    stopColor: "#FCC5BE",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/Two.6a6ffd45627ed0759ab6c9f8d473ea0b.svg";
export { ForwardRef as ReactComponent };